import Common from '../common'
var Js = Common('tproduct')
export default {
	name: 'tproduct',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 50
				},
				{
					key: 'product_no',
					label: '商品NO',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 100
				},
				{
					key: 'title',
					label: '商品名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入商品名称',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.title = val;
							} else {
								delete self.searchItem.title;
							};

						},
					},
				},
				{
					key: 'price',
					label: '展示价格',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					width:120
				},
				{
					key: 'duration',
					label: '限时时间',
					application: ['编辑', '添加'],
					componentName: 'sls-datetime',
					listType: 'normal',
					width:150
				},
				{
					key: 'total_sale_count',
					label: '销量',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width:120
				},
				{
					key: 'listorder',
					label: '排序',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					width:100
				},
				{
					key: 'content',
					label: '内容',
					application: ['编辑', '添加'],
					componentName: 'tinymce-editor',
					listType: '',
					dialogStyle: 'width:90%',
				},
				{
					key: 'mainImg',
					label: '主图',
					customSlot: 'mainImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: 'normal',
					limit: 10,
					dialogStyle: 'width:90%',
					width: 100
				},
				{
					key: 'bannerImg',
					label: '轮播图',
					customSlot: 'bannerImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: '',
					limit: 10,
					dialogStyle: 'width:90%',
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 160,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 170
				},
			],
			// 按钮配置
			btn_info: [{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							if(self.submitData.duration){
								self.submitData.duration = self.submitData.duration/1000;
							}
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '商品库存'
					},
					func: {
						apiName: function(self) {
							return "api_productDateUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							self.submitData.stock = parseInt(self.submitData.stock);
							var postData = {
								searchItem: {
									product_no: self.formData.product_no,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_productAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								content: '',
								price: '',
								mainImg: [],
								bannerImg: [],
								img_array: []
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 2;
							self.submitData.category_id = 21;
							if(!self.submitData.duration){
								self.$message({message: '请选择特卖限时时间',type: 'warning'});
								return;
							}
							self.submitData.stock = 9999999;
							self.submitData.duration = self.submitData.duration/1000;
							var postData = {
								data: self.submitData
							};
							postData.saveAfter = [{
								tableName: 'ProductDate',
								FuncName: 'add',
								data: {
									res: {
										product_no: 'product_no'
									},
									type: 1,
									is_template: 0,
									stock: 9999999
								}
							}]
							console.log(postData)
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '商品规格'
					},
					funcType: 'func',
					func: {
						func: function(self) {

							self.$router.push({
								path: '/home/sku',
								name: 'SKU管理',
								params: {
									product_id: self.originFormData.id,
									path: '/home/tproduct',
									delKeepAlive: true
								}
							});
						},
					},
				},
			],

			searchItem: {
				type: 2,
				category_id:21
			},
			startSearchItem: {
				type: 2,
				category_id:21
			},
			optionData: {
				labelOptions: [],
				skuOptions: [],
				typeOptions: [{
					text: '是',
					value: 1
				}, {
					text: '否',
					value: 0
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			// this.initLabelData();
		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				realStock: {
					tableName: 'ProductDate',
					middleKey: 'product_no',
					key: 'product_no',
					condition: '=',
					info: ['stock']
				}
			}
			var res = await self.$$api_productGet({
				data: postData
			});
			if(res.info.data.length>0){
				res.info.data.forEach((item,index)=>{
					item.duration = self.$$timeto(item.duration*1000,'ymd-hm')
				})
			}
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		}

	},


}



// WEBPACK FOOTER //
// ./src/views/product/tproduct.js